import type { LearnerSearchResultItem } from '../types';
import AssetPickerTypes from '~/components/common/asset-picker/asset-picker-types';
import { CMSTopLevelContentTypes, learnerGoToCmsContentViaSearchResult } from '~/elc/features/cms';
import { SearchResultContentTypes } from '../constants';

export const openSearchResult = (item: LearnerSearchResultItem) => {
  if (item.type === CMSTopLevelContentTypes.CMS_FILE || item.type === CMSTopLevelContentTypes.CMS_LINK) {
    return learnerGoToCmsContentViaSearchResult(item.id, item.type as CMSTopLevelContentTypes);
  }

  const url = AssetPickerTypes.getViewItemUrl({ id: item.id, type: item.type });

  if (item.type === 'scorm' || item.type === SearchResultContentTypes.CONTENT_PROVIDER_CONTENT) {
    return window.open(url, '_blank');
  }

  return window.location.assign(url);
};
